import React from 'react';
import styled from 'styled-components';
import {
  fontSize,
  fontWeights,
  minBreakpointQuery,
  sectionMargins,
} from '../styles';
import { Container, Heading } from './ui';

const StyledFeaturedIcons = styled.section`
  ${sectionMargins()};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 30px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 35px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 40px;
  `}
`;

const StyledItems = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 20px;
`;

const StyledItem = styled.div`
  width: calc((100% - 20px) / 2);
  text-align: center;

  ${minBreakpointQuery.tsmall`
    width: calc((100% - 60px) / 4);
  `}
`;

const StyledIcon = styled.img`
  height: 40px;
  width: 40px;

  ${minBreakpointQuery.small`
    height: 50px;
    width: 50px;
  `}

  ${minBreakpointQuery.large`
    height: 60px;
    width: 60px;
  `}
`;

const StyledText = styled.p`
  margin-top: 6px;
  font-weight: ${fontWeights.bold};
  ${fontSize(14)};

  ${minBreakpointQuery.small`
    ${fontSize(15)};
  `}

  ${minBreakpointQuery.large`
    margin-top: 8px;
    ${fontSize(16)};
  `}
`;

const FeaturedIcons = ({ heading, items }) => (
  <StyledFeaturedIcons>
    <Container>
      <StyledHeading>{heading}</StyledHeading>
      <StyledItems>
        {items.map(({ url, alt, title }, id) => (
          <StyledItem key={id}>
            <StyledIcon src={url} alt={alt} loading="lazy" />
            <StyledText>{title}</StyledText>
          </StyledItem>
        ))}
      </StyledItems>
    </Container>
  </StyledFeaturedIcons>
);

export default FeaturedIcons;
